<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 文章内容 -->
    <div class="div">
      <div class="ThereIsNo">
        <div class="QRcode">
          <img
            src="../../../assets/images/dynamicInformation/Information/QRcode.png"
            alt=""
          />
          <p>
            微信扫一扫 <br />
            关注该公众号
          </p>
        </div>
      </div>
      <div class="essayOne">
        <h2>如何精准精监控、降低环保处罚风险？园区环保信息化平台如何建？</h2>
        <div class="time"><a href="#">环保大讲坛</a>&nbsp; 2022-04-19 17:06</div>
        <div class="texts">
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img000.png"
            alt=""
          />
          <p style="padding: 20px 0">
            环保督查常态化，工业园区企业多、专业人员少，使得园区环保管理压力越来越大，如何高效管
            理，从容应对督查检查，是园区面临的难题，这时您需要一款专业的环保软件和服务团队。<i
              style="color: #ff0000; font-weight: 700"
            >
              中泽宇华环保管理系统紧抓环保管理要点，有效提高环保管理人员工作的效率；同时也能帮助
              第三方企业进行标准化、规范化的环保服务，提升服务质量。</i
            >
          </p>
          <i style="color: #222222; font-size: 17px; font-weight: 700"
            >一、环保管理的难点</i
          >

          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img001.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img002.png"
            alt=""
            style="padding-top: 20px"
          />
          <i style="color: #222222; font-size: 17px; font-weight: 700"
            >中泽宇华企业环保平台--能做什么？</i
          >
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img003.png"
            alt=""
          />

          <i style="color: #222222; font-size: 17px">二、功能特点</i> <br />
          <i style="color: #222222; font-size: 17px; font-weight: 700">
            一，穿透式管理</i
          >
          <p>
            管理端能直接查看各企业（各车间）污染源分布、数量统计、污染种类、排放量等统计数据，同时可以直接链接查看数据详情
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img004.png"
            alt=""
          />
          <i style="color: #222222; font-size: 17px; font-weight: 700">
            二，检查自查</i
          >
          <p style="padding-bottom: 20px">
            各部门负责人可以快速了解本企业环保情况，污染物种类、排放量、实时监测数据、上级通知、报警提示等。检查有针对性，自查有目标。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img005.png"
            alt=""
          />

          <i style="color: #222222; font-size: 17px; font-weight: 700">
            三、功能模块</i
          >
          <p style="padding-bottom: 20px">
            1、废水监测系统包括：排口信息、排口自行监测、排口在线监测、管网可视化、预警预报等5大
            模块，在“一张图”总体框架下，利用GIS技术建立企业雨污管网图，包含管网长度、管径、埋地
            深度、检修井、采样点、在线监测等数字信息，内置预警报警数据分析模型，对企业异常排放、
            超标排放、雨污混流等进行监管，及时发现问题，及时处理。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img006.png"
            alt=""
          />
          <p>
            2、废气监测系统包括：废气排口基础信息，自行监测、在线监测、厂界微站、有毒有害气体监测、
            可燃气报警监测、预警报警模块，通过动态数据和静态数据结合，全面掌握企业排气排放现况。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img007.png"
            alt=""
          />
          <p>
            3、固废管控系统包括：一般固废和危险废物管理两大模块，通过对固废的产生、暂存、转运等全过
            程电子化跟踪，利用4G电子秤、视频监控等手段，实时掌握企业固废现状。系统能对固废进行分类统
            计，对超期存储，超量存储、产转异常进行自动预警报警。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img008.png"
            alt=""
          />
          <p>
            4、视频监系统包括站房视频、车间视频、门禁视频等，系统集成多种品牌多种格式视频，通过视频
            应用引擎将多种格式的视频数据转化为统一的视频数据，不需要在平台上安装多种视频插件，能够在
            平台界面上进行多种品牌多种格式视频流畅播放。同时视频可自由分配，关联对应在线监测设备，方
            便更直观地掌握企业排放现状和生产现状。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img009.png"
            alt=""
          />
          <p>
            5、预警报警模块。系统内置13大项预警报警模块，对废气在线监测、废水在线监测、治理设施用电、
            用水数据、排污许可数据进行多维度联动分析，自动诊断异常数据并将预警报警数据推送至相关负责人，
            精准监管。同时企业可通过APP、微信、PC端实时查看企业环保设施运行情况，异常数据自动以短信、
            微信推送至环保负责人，及时处理及时整改，有效降低环保处罚风险和因处理不及时带来的环境影响。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img010.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img011.png"
            alt=""
          />
          <p>
            6、“一企一档”模块按照排污许可台账管理要求进行设计，通过对企业基本信息，污染治理设施、
            监测检测等进行标准化管理，对存在问题的数据进行预警报警，促进企业环保管理水平的提升。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img012.png"
            alt=""
          />
          <p>
            7、微信小程序、APP因使用方便、快捷在环保管理方面发挥着越来越重要的作用，移动端和PC端
            数据共享，通过APP、小程序随时查看企业的基础信息、在线数据、视频数据、预警报警数据等，
            快速掌握企业环保管理现状。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img013.png"
            alt=""
          />
          <p>
            8、排放量自动统计核算 <br />
            在线监测自动核算 <br />
            自行监测自动核算<br />
            自主核算（公式法、物料衡算法、系统法）<br />
            各类核算统计比较、多维度统计排放结果<br />
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img014.png"
            alt=""
          />
          <p>
            9、企业跟踪管理 <br />
            1.现状评估及整改意见 <br />
            2.整改进度跟踪 <br />
            3.时间节点提醒
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img015.png"
            alt=""
          />
          <p style="color: #222222; font-size: 17px; font-weight: 700">
            四、我们的优势是什么
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img016.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img017.png"
            alt=""
          />

          <p style="text-indent: 0">
            中泽宇华专注环保管理软件开发，因为专注，所以专业，欢迎咨询！<br />
            地址：北京市大兴区西红门兴创国际中心S座809室 <br />
            武汉市经济开发区东合中心E座506室<br />
            联系人：方经理<br />
            联系电话：010-80251293 、18510508157（微信同号）<br />
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img018.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },

  data() {
    return {};
  },
  created() {
    this.$store.state.menu = 4;
  },
};
</script>
<style
  lang="scss"
  src="../../../assets/css/dynamicInformation/Information.scss"
></style>
